(function () {
  var SHIPPING_MAX_AGE_MS = 30 * 60 * 1000;

  function normalizeCep(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function parseMoneyToCents(text) {
    if (!text) return null;

    var normalizedText = String(text).trim();
    if (!normalizedText) return null;

    if (/grátis|gratis/i.test(normalizedText)) return 0;

    var normalized = normalizedText
      .replace(/\s/g, '')
      .replace('R$', '')
      .replace(/\./g, '')
      .replace(',', '.')
      .trim();

    var value = Number(normalized);
    if (!Number.isFinite(value)) return null;

    return Math.round(value * 100);
  }

  function getCurrentVariantId() {
    try {
      var params = new URLSearchParams(window.location.search);

      if (params.get('variant')) {
        return String(params.get('variant'));
      }

      if (typeof meta !== 'undefined' && meta.product && meta.product.variants && meta.product.variants[0]) {
        return String(meta.product.variants[0].id);
      }

      if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.selectedVariantId) {
        return String(ShopifyAnalytics.meta.selectedVariantId);
      }
    } catch (e) {}

    return '';
  }

  function getCurrentProductQuantity() {
    var qtyInput =
      document.querySelector("input[name='quantity']") ||
      document.querySelector('#quantity') ||
      document.querySelector('#quantity2') ||
      document.querySelector("input.quantity__input");

    var qty = qtyInput ? Number(qtyInput.value) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getCartSignature() {
    var summary = document.querySelector('[data-mini-cart-summary]');
    if (!summary) return '';
    return String(summary.dataset.cartTotalCents || '');
  }

  function getStoredMiniCartShipping() {
    if (window.miniCartShippingQuote && typeof window.miniCartShippingQuote.get === 'function') {
      return window.miniCartShippingQuote.get();
    }
    return null;
  }

  function setStoredMiniCartShipping(data) {
    if (window.miniCartShippingQuote && typeof window.miniCartShippingQuote.set === 'function') {
      window.miniCartShippingQuote.set(data);
    }
  }

  function clearStoredMiniCartShipping() {
    if (window.miniCartShippingQuote && typeof window.miniCartShippingQuote.clear === 'function') {
      window.miniCartShippingQuote.clear();
    }
  }

  function syncMiniCartSummary() {
    if (window.miniCartShippingQuote && typeof window.miniCartShippingQuote.sync === 'function') {
      window.miniCartShippingQuote.sync();
    }
  }

  function parseDeliveryText(text) {
    if (!text) return { days: null, label: '' };

    var normalized = String(text).trim();
    var match = normalized.match(/\d+/);
    var days = match ? Math.floor(Number(match[0])) : null;

    if (!Number.isFinite(days)) {
      return { days: null, label: normalized };
    }

    return {
      days: days,
      label: '' + days + ' ' + (days === 1 ? 'dia útil' : 'dias úteis')
    };
  }

  function captureShippingFromProductApp() {
    var calcCarrier = document.getElementById('calc-carrier');
    var zipcodeInput = document.getElementById('zipcode');
    var localization = document.querySelector('.localization span');

    if (!calcCarrier) return;

    var priceNodes = calcCarrier.querySelectorAll('.ship-price');
    if (!priceNodes.length) return;

    var lowestRate = null;

    priceNodes.forEach(function (node) {
      var cents = parseMoneyToCents(node.textContent);
      if (cents === null) return;

      var row = node.closest('li');
      var shipNameNodes = row ? row.querySelectorAll('.ship-name span') : [];
      var serviceText = shipNameNodes[0] ? shipNameNodes[0].textContent.trim() : 'Transportadora';
      var deliveryText = shipNameNodes[1] ? shipNameNodes[1].textContent.trim() : '';
      var delivery = parseDeliveryText(deliveryText);

      var currentRate = {
        priceCents: cents,
        priceLabel: cents === 0 ? 'Grátis' : node.textContent.trim(),
        service: serviceText,
        deliveryDays: delivery.days,
        deliveryLabel: delivery.label
      };

      if (!lowestRate) {
        lowestRate = currentRate;
        return;
      }

      if (currentRate.priceCents < lowestRate.priceCents) {
        lowestRate = currentRate;
        return;
      }

      if (currentRate.priceCents === lowestRate.priceCents) {
        var currentDays = Number.isFinite(currentRate.deliveryDays) ? currentRate.deliveryDays : Number.POSITIVE_INFINITY;
        var lowestDays = Number.isFinite(lowestRate.deliveryDays) ? lowestRate.deliveryDays : Number.POSITIVE_INFINITY;
        if (currentDays < lowestDays) {
          lowestRate = currentRate;
        }
      }
    });

    if (!lowestRate) return;

    var cep = normalizeCep(zipcodeInput ? zipcodeInput.value : '');
    if (!cep) return;

    var deliveryDateLabel = '';
    if (window.miniCartShippingQuote && typeof window.miniCartShippingQuote.getFormattedDeliveryDate === 'function') {
      deliveryDateLabel = window.miniCartShippingQuote.getFormattedDeliveryDate(lowestRate.deliveryDays);
    }

    var payload = {
      source: 'product_app',
      priceCents: lowestRate.priceCents,
      priceLabel: lowestRate.priceCents === 0 ? 'Grátis' : lowestRate.priceLabel,
      service: lowestRate.service,
      cep: cep,
      location: localization ? localization.textContent.trim() : '',
      productPath: window.location.pathname || '',
      variantId: getCurrentVariantId(),
      quantity: getCurrentProductQuantity(),
      cartSignature: getCartSignature(),
      deliveryDays: lowestRate.deliveryDays,
      deliveryLabel: lowestRate.deliveryLabel,
      deliveryDateLabel: deliveryDateLabel,
      timestamp: Date.now()
    };

    setStoredMiniCartShipping(payload);
    syncMiniCartSummary();
  }

  function observeProductShippingApp() {
    var calcCarrier = document.getElementById('calc-carrier');
    var form = document.getElementById('formKokfyShipping');

    if (!calcCarrier || !form) return;

    var observer = new MutationObserver(function () {
      captureShippingFromProductApp();
    });

    observer.observe(calcCarrier, {
      childList: true,
      subtree: true,
      characterData: true
    });

    form.addEventListener('click', function (event) {
      var button = event.target.closest('.btnForm');
      if (!button) return;

      setTimeout(captureShippingFromProductApp, 1200);
      setTimeout(captureShippingFromProductApp, 2200);
    });

    form.addEventListener('keyup', function (event) {
      if (event.target && event.target.id === 'zipcode' && (event.key === 'Enter' || event.keyCode === 13)) {
        setTimeout(captureShippingFromProductApp, 1200);
        setTimeout(captureShippingFromProductApp, 2200);
      }
    });

    captureShippingFromProductApp();
  }

  function removeExpiredQuote() {
    var data = getStoredMiniCartShipping();
    if (!data || !data.timestamp) return;

    if (Date.now() - Number(data.timestamp) > SHIPPING_MAX_AGE_MS) {
      clearStoredMiniCartShipping();
      syncMiniCartSummary();
    }
  }

  function bindMiniCartEvents() {
    document.addEventListener('cartdrawer:opened', function () {
      syncMiniCartSummary();
    });

    document.addEventListener('cart:refresh', function () {
      syncMiniCartSummary();
    });

    document.addEventListener('cart:updated', function () {
      setTimeout(syncMiniCartSummary, 80);
      setTimeout(syncMiniCartSummary, 220);
    });
  }

  function init() {
    removeExpiredQuote();
    observeProductShippingApp();
    bindMiniCartEvents();
    syncMiniCartSummary();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.productPageShippingSync = {
    getStoredShipping: getStoredMiniCartShipping,
    clearStoredShipping: clearStoredMiniCartShipping,
    syncMiniCartSummary: syncMiniCartSummary
  };
})();